import type { ResolvedTheme } from '@/types/client-config'

export function applyTheme(theme: ResolvedTheme): void {
  const existing = document.getElementById('client-theme')
  if (existing) existing.remove()

  const toVars = (vars: Record<string, string>) =>
    Object.entries(vars)
      .map(([key, value]) => `  --${key}: ${value};`)
      .join('\n')

  const sharedVars = toVars(theme.shared)
  const lightVars = toVars(theme.light)
  const darkVars = toVars(theme.dark)

  const style = document.createElement('style')
  style.id = 'client-theme'
  style.textContent = `:root {\n${sharedVars}\n${lightVars}\n}\n.dark {\n${darkVars}\n}`
  document.head.appendChild(style)
}
